/**
 * 1.8.4 §3 (D-1.8.4-3) — Today's two reads: GET /api/house-today?day=yyyyMMdd (Needs your attention, the day's
 * housekeeping visits, the scheduled emails, the recent reports) and the house calendar's month (GET /api/calendar,
 * 1.8.2 — the other programs' lines and the month to pick a day from). Nothing here writes.
 */
import { useQuery } from '@tanstack/react-query';
import type { HouseTodayResponse } from '@shared/house-today';
import { apiFetch } from '@/lib/api';

export { useHouseCalendar } from '@/features/calendar/api';

export function useHouseToday(day: string) {
  return useQuery({
    queryKey: ['house-today', day],
    queryFn: () => apiFetch<HouseTodayResponse>(`/api/house-today?day=${encodeURIComponent(day)}`),
    staleTime: 30_000,
  });
}
